import { SELECT_ALL } from '../constants/common';

export const RECOMMENDATIONS_ACTIONS = {
    RECO_TOGGLE_FILTER_DROPDOWN: "RECO_TOGGLE_FILTER_DROPDOWN",
    RECO_TOGGLE_DROPDOWN_APPLIANCES_CHECKBOX_ALL: "RECO_TOGGLE_DROPDOWN_APPLIANCES_CHECKBOX_ALL",
    RECO_TOGGLE_DROPDOWN_APPLIANCES_CHECKBOX: "RECO_TOGGLE_DROPDOWN_APPLIANCES_CHECKBOX",
    RECO_SHOW_LOADER: "RECO_SHOW_LOADER",
    RECO_SHOW_MORE: "RECO_SHOW_MORE",
    RESET_DATA: "RESET_DATA",
    ON_UNSELECT_ALL_RECOS_DROPDOWN: 'ON_UNSELECT_ALL_RECOS_DROPDOWN',
    SET_DROPDOWN_VALUES: 'SET_DROPDOWN_VALUES',
    FETCHING_DETAILS : 'FETCHING_DETAILS',
    QUERY_RECO_CARD_LOADED : 'QUERY_RECO_CARD_LOADED',
    SET_ALLOWED_APPLIANCES : 'SET_ALLOWED_APPLIANCES'
};
export const RECOMMENDATIONS_DATA_FETCHER_ACTIONS = {
    FETCH_RECO_TOP_5: "FETCH_RECO_TOP_5",	
    FETCH_TIPS_TO_SAVE_ENERGY: "FETCH_TIPS_TO_SAVE_ENERGY",	
    FETCH_RECO_PROGRAMS: "FETCH_RECO_PROGRAMS",	
    SET_UNREAD_RECOS: "SET_UNREAD_RECOS",	
    ON_RECO_LIKE: "ON_RECO_LIKE",	
    ON_RECO_UNLIKE: "ON_RECO_UNLIKE",
    FETCH_RECO_DETAILS : "FETCH_RECO_DETAILS",
    FETCH_RECO_DETAILS_FAILURE : "FETCH_RECO_DETAILS_FAILURE",
    UPDATING_LIKES : "UPDATING_LIKES"
};

export function setDropdownValues(payload) {
    return {
        type: RECOMMENDATIONS_ACTIONS.SET_DROPDOWN_VALUES,
        payload: payload
    }
}

export function toggleFilterDropdown(payload) {
    return {
        type: RECOMMENDATIONS_ACTIONS.RECO_TOGGLE_FILTER_DROPDOWN,
        payload: payload
    }
}

export function toggleRecoDropdownCheckbox(payload) {
    if (payload === SELECT_ALL) {
        return {
            type: RECOMMENDATIONS_ACTIONS.RECO_TOGGLE_DROPDOWN_APPLIANCES_CHECKBOX_ALL,
            payload: payload
        }
    }else {
        return {
            type: RECOMMENDATIONS_ACTIONS.RECO_TOGGLE_DROPDOWN_APPLIANCES_CHECKBOX,
            payload: payload
        }
    }
}

export function showRecoLoader() {
    return {
        type: RECOMMENDATIONS_ACTIONS.RECO_SHOW_LOADER
    }
}

export function showMoreRecos() {
    return {
        type: RECOMMENDATIONS_ACTIONS.RECO_SHOW_MORE
    }
}

export function onUnselectAllRecosDropdown() {
    return {
        type: RECOMMENDATIONS_ACTIONS.ON_UNSELECT_ALL_RECOS_DROPDOWN
    }
}

export function setUpdatingLikes(recoIndex){
    return{
        type : RECOMMENDATIONS_DATA_FETCHER_ACTIONS.UPDATING_LIKES,
        payload : recoIndex
    }
}

export function setAllowedAppliances(allowedAppList){
    return{
        type : RECOMMENDATIONS_ACTIONS.SET_ALLOWED_APPLIANCES,
        payload : allowedAppList
    }
}